import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { adminLogout } from "../redux/adminSlice/adminAuthSlice";
import { useAdminProfile } from "../components/common/hooks/useAdminProfileQuery";

const AdminHeader = ({ onMenuToggle, title }) => {
    const [openHeader, setOpenHeader] = useState(false);
    const [open, setOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1250);
    const [user, setUser] = useState(null);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [showNotifications, setShowNotifications] = useState(false);
    const profileRef = useRef(null);
    const notificationRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {
        data: adminProfile,
        isLoading: profileLoading,
        error: profileError,
        refetch: refetchProfile
    } = useAdminProfile();

    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'adminData') {
                refetchProfile();
            }
        };

        const handleLogin = () => {
            refetchProfile();
        };

        const handleLogout = () => {
            setUser(null);
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('login', handleLogin);
        window.addEventListener('logout', handleLogout);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('login', handleLogin);
            window.removeEventListener('logout', handleLogout);
        };
    }, [refetchProfile]);

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("open") || "false");
        setOpenHeader(stored);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfileMenu(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1250);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLogout = async () => {
        await dispatch(adminLogout());
        window.dispatchEvent(new Event('logout'));
        navigate('/admin/login', { replace: true });
    };

    const getUserName = () => {
        if (user?.firstName && user?.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return adminProfile?.fullName || "Admin";
    };
    const handleSidebar = () => {
        const value = localStorage.getItem("open") === "true";

        localStorage.setItem("open", String(!value));

        window.dispatchEvent(new Event("sidebarToggle"));
    };

    const getInitials = () => {
        const name = getUserName();
        return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    };

    const unreadCount = notifications.filter(n => !n.read).length;

    return (
        <header style={{
            background: '#bc0e23',
            padding: '0 24px',
            height: '70px',
            display: 'flex',
            alignItems: 'center',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
        }}>
            <div className="tablet_header d-flex align-items-center">
                {isMobile && (<button onClick={handleSidebar} class={"menu-toggle"}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>)}
                <Link><img src="/image/logo.png" alt="" /></Link>
            </div>
            <div style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                }}>


                    {title && (
                        <h3 style={{
                            margin: 0,
                            color: 'white',
                            fontSize: '20px',
                            fontWeight: 600,
                            letterSpacing: '0.5px',
                        }}>
                            {title}
                        </h3>
                    )}
                </div>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                }}>
                    <div ref={notificationRef} style={{ position: 'relative' }}>
                        <button
                            onClick={() => setShowNotifications(!showNotifications)}
                            style={{
                                background: 'rgba(255,255,255,0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '44px',
                                height: '44px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                position: 'relative',
                                color: 'white',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                                e.currentTarget.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                            </svg>
                            {unreadCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-4px',
                                    right: '-4px',
                                    background: '#ff4757',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    fontSize: '11px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    boxShadow: '0 2px 6px rgba(255,71,87,0.4)',
                                }}>
                                    {unreadCount}
                                </span>
                            )}
                        </button>

                        {showNotifications && (
                            <div style={{
                                position: 'absolute',
                                top: 'calc(100% + 12px)',
                                right: 0,
                                background: 'white',
                                borderRadius: '12px',
                                boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                                width: '360px',
                                maxHeight: '400px',
                                overflow: 'auto',
                                animation: 'slideDown 0.3s ease',
                            }}>
                                <div style={{
                                    padding: '16px 20px',
                                    borderBottom: '1px solid #f0f0f0',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}>
                                    <h4 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }}>
                                        Notifications
                                    </h4>
                                    <button style={{
                                        border: 'none',
                                        background: 'transparent',
                                        color: '#667eea',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                    }}>
                                        Mark all read
                                    </button>
                                </div>
                                <div style={{ padding: '8px 0' }}>
                                    {notifications?.map(notification => (
                                        <div key={notification.id} style={{
                                            padding: '12px 20px',
                                            borderBottom: '1px solid #f5f5f5',
                                            cursor: 'pointer',
                                            transition: 'background 0.2s',
                                            background: notification.read ? 'white' : '#f8f9ff',
                                        }}
                                            onMouseEnter={(e) => e.currentTarget.style.background = '#f0f0f0'}
                                            onMouseLeave={(e) => e.currentTarget.style.background = notification.read ? 'white' : '#f8f9ff'}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                            }}>
                                                <span style={{
                                                    fontSize: '14px',
                                                    color: '#333',
                                                    fontWeight: notification.read ? 'normal' : '600',
                                                }}>
                                                    {notification.text}
                                                </span>
                                                <span style={{
                                                    fontSize: '11px',
                                                    color: '#999',
                                                }}>
                                                    {notification.time}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div style={{
                                    padding: '12px 20px',
                                    borderTop: '1px solid #f0f0f0',
                                    textAlign: 'center',
                                }}>
                                    <Link to="/admin/notifications" style={{
                                        color: '#667eea',
                                        textDecoration: 'none',
                                        fontSize: '14px',
                                    }}>
                                        View all notifications
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>

                    <div ref={profileRef} style={{ position: 'relative' }}>
                        <div
                            onClick={() => setShowProfileMenu(!showProfileMenu)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                cursor: 'pointer',
                                padding: '6px 12px 6px 6px',
                                borderRadius: '50px',
                                background: showProfileMenu ? 'rgba(255,255,255,0.2)' : 'transparent',
                                transition: 'all 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                if (!showProfileMenu) {
                                    e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!showProfileMenu) {
                                    e.currentTarget.style.background = 'transparent';
                                }
                            }}
                        >
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '16px',
                            }}>
                                {getInitials()}
                            </div>
                            <div style={{ display: 'none' }} className="d-sm-block">
                                <div style={{
                                    color: 'white',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    lineHeight: '1.2',
                                }}>
                                    {getUserName()}
                                </div>
                                <div style={{
                                    color: 'rgba(255,255,255,0.7)',
                                    fontSize: '12px',
                                }}>
                                    {adminProfile?.email || 'Admin'}
                                </div>
                            </div>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                                <path d="M6 9l6 6 6-6" />
                            </svg>
                        </div>

                        {showProfileMenu && (
                            <div style={{
                                position: 'absolute',
                                top: 'calc(100% + 12px)',
                                right: 0,
                                background: 'white',
                                borderRadius: '12px',
                                boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                                minWidth: '220px',
                                animation: 'slideDown 0.3s ease',
                                overflow: 'hidden',
                            }}>
                                <div style={{
                                    padding: '16px 20px',
                                    borderBottom: '1px solid #f0f0f0',
                                }}>
                                    <div style={{ fontWeight: 600, color: '#333', fontSize: '14px' }}>
                                        {getUserName()}
                                    </div>
                                    <div style={{ color: '#999', fontSize: '13px' }}>
                                        {adminProfile?.email || 'admin@example.com'}
                                    </div>
                                </div>
                                <div style={{ padding: '8px 0' }}>
                                    <Link to="#" style={{
                                        display: 'block',
                                        padding: '10px 20px',
                                        color: '#333',
                                        textDecoration: 'none',
                                        transition: 'background 0.2s',
                                        fontSize: '14px',
                                    }}
                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                        onClick={() => setShowProfileMenu(false)}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                                <circle cx="12" cy="7" r="4" />
                                            </svg>
                                            My Profile
                                        </div>
                                    </Link>
                                    <Link to="#" style={{
                                        display: 'block',
                                        padding: '10px 20px',
                                        color: '#333',
                                        textDecoration: 'none',
                                        transition: 'background 0.2s',
                                        fontSize: '14px',
                                    }}
                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                        onClick={() => setShowProfileMenu(false)}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
                                                <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                                            </svg>
                                            Change Password
                                        </div>
                                    </Link>
                                </div>
                                <div style={{ borderTop: '1px solid #f0f0f0', padding: '8px 0' }}>
                                    <button onClick={handleLogout} style={{
                                        display: 'block',
                                        width: '100%',
                                        padding: '10px 20px',
                                        border: 'none',
                                        background: 'transparent',
                                        color: '#ff4757',
                                        cursor: 'pointer',
                                        textAlign: 'left',
                                        fontSize: '14px',
                                        transition: 'background 0.2s',
                                    }}
                                        onMouseEnter={(e) => e.currentTarget.style.background = '#fff5f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                <polyline points="16 17 21 12 16 7" />
                                                <line x1="21" y1="12" x2="9" y2="12" />
                                            </svg>
                                            Logout
                                        </div>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </header>
    );
};

export default AdminHeader;